/* eslint-disable */
import sysConfig from '@/configs/sys';

const matlsApiUrl = sysConfig.matlsApiUrl;

export default {
  getKnowledges(keyword = '') {
    keyword = encodeURIComponent(keyword);
    return fetch
      .get(`${matlsApiUrl}/knowledge/getknowsbykeyword/${keyword}`)
      .then(res => res.json());
  }
};